import {
  Box,
  Dialog,
  DialogContent,
  makeStyles,
  Typography,
  Button,
} from '@material-ui/core'
import { useState } from 'react'
import Api from '../Apis/api.service'
const useStyles = makeStyles(() => ({
  Button: {
    backgroundColor: '#143A5F',
    color: 'white',
    cursor: 'pointer',
    fontWeight: '600',
    '&:hover': {
      background: 'white !important',
      color: '#143A5F !important',
      border: '1px solid #143A5F',
    },
    '&:disabled': {
      background: 'white !important',
      color: '#143A5F !important',
      border: '1px solid #143A5F',
    },
  },
}))
export const PreferencesDialog = ({
  data,
  showDialog,
  toggleDialog,
  id,
  ...props
}) => {
  const [selectedOption, setSelectedOption] = useState('')
  const { poidsPapier, co2, montant } = props
  const handleVoie = async (val) => {
    const res = await Api.extContactpref.updateDigitalConsent(id, {
      paper: val == 'voie-postale' ? true : false,
    })
    if (res.status == 200) {
      if (res.data.ok) {
        setSelectedOption(val)
        toggleDialog()
      } else {
        console.log({ res: res.data })
      }
    }
  }
  const classes = useStyles()
  return (
    <Dialog
      open={showDialog}
      onClose={toggleDialog}
      fullWidth={true}
      maxWidth={'sm'}
    >
      <DialogContent>
        <Typography
          style={{
            marginTop: '20px',
            fontSize: '20px',
            color: '#133a5f',
            lineHeight: '31.2px',
            fontWeight: '700',
            fontFamily: 'Helvetica',
          }}
        >
          Votre préférence de communication n'est pas renseignée
        </Typography>
        <Typography style={{ margin: '20px 0' }}>
          <b>
            Vous avez la possibilité de recevoir l'ensemble des documents par
            voie électronique (par mail simple, par remise contre signature, ou
            par recommandé électronique) plutôt que par voie postale. Pourquoi
            opter pour le tout numérique ?
          </b>
        </Typography>
        <ul style={{ lineHeight: '27px' }}>
          <li>
            Un gain de temps, aucun délai postal, vous recevez les documents
            plus rapidement
          </li>
          <li>
            Un gain pour la planète, dans le cadre de votre copropriété cela
            correspond à {poidsPapier} de papier,
            {co2} de CO2.
          </li>
          <li>Un gain pour la copropriété de {montant}</li>
        </ul>
        <Box
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '20px',
          }}
        >
          <Button
            className={classes.Button}
            disabled={selectedOption === 'voie-postale'}
            style={{ marginRight: '10px' }}
            variant="contained"
            onClick={() => {
              handleVoie('voie-postale')
            }}
            disableElevation
          >
            Opter pour le papier
          </Button>
          <Button
            className={classes.Button}
            disabled={selectedOption === 'voie-digitale-securisee'}
            variant="contained"
            onClick={() => {
              handleVoie('voie-digitale-securisee')
            }}
            disableElevation
          >
            Opter pour le numérique
          </Button>
        </Box>
        <Typography style={{ fontSize: '12.5px' }}>
          <span style={{ display: 'block' }}>
            Les informations recueillies sur ce formulaire sont enregistrées
            dans un fichier informatisé par Manda (Ex-Hello Syndic) dans le
            cadre du contrat qui lie les copropriétaires à Manda (Ex-Hello
            Syndic). Les données collectées seront communiquées aux seuls
            destinataires suivants : Manda (Ex-Hello Syndic), ou toute société
            mandatée dans le cadre d’une intervention dans le cadre de
            l’activité de Manda (Ex-Hello Syndic). Vous pouvez retirer à tout
            moment votre consentement au traitement de vos données. Vous pouvez
            également vous opposer au traitement de vos données. Vous pouvez
            également exercer votre droit à la portabilité de vos données.
            Consultez le site cnil.fr pour plus d’informations sur vos droits.
            Pour exercer ces droits ou pour toute question sur le traitement de
            vos données dans ce dispositif, vous pouvez contacter copro@manda.fr
            ou via Manda (Ex-Hello Syndic), 30 Terrasse Bellini - 92800 Puteaux
          </span>
          <span>
            Vous pouvez accéder aux données vous concernant, les rectifier,
            demander leur effacement ou exercer votre droit à la limitation du
            traitement de vos données.
          </span>
        </Typography>
      </DialogContent>
    </Dialog>
  )
}
export default PreferencesDialog
